import { CHRISTOLOGICAL_DOGMAS } from "./dogmasChristological";
import { GRACE_DOGMAS } from "./dogmasGrace";
import { SUB_TUUM } from "./historicalPrayers";
export const DOGMA_GUIDES = [...CHRISTOLOGICAL_DOGMAS, ...GRACE_DOGMAS].map((d) => ({ ...d, prayer: SUB_TUUM.text, prayerSource: SUB_TUUM }));